import Image from "./Image";
import Video from "./Video";
import DocumentCustom from "./DocumentCustom";
import Audio from "./Audio";
import AudioTemp from "./AudioTemp";
import Contact from "./Contact";
import MultiChoice from "./MultiChoice";
import Location from "./Location";

export {
	Image,
	Video,
	Audio,
	DocumentCustom,
	AudioTemp,
	Contact,
	MultiChoice,
	Location
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/index.js